export default function Flow() {
  const steps = [
    {
      number: '1',
      title: 'LINEで友だち追加',
      description: 'ボタンを押すだけ'
    },
    {
      number: '2',
      title: '役割を選ぶ',
      description: '先行テスター / 投稿者（動画ログ）'
    },
    {
      number: '3',
      title: '案内に沿って参加',
      description: 'Ver.0前後のテスト/投稿を進めます'
    }
  ];

  return (
    <section id="flow" className="py-20 bg-[#F8F8F8]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Title */}
        <h2 className="text-4xl font-bold text-center text-[#111111] mb-16">
          参加の流れ（3ステップ）
        </h2>

        {/* Steps Grid */}
        <div className="grid md:grid-cols-3 gap-6 mb-12 relative">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Card */}
              <div
                className="bg-white rounded-2xl p-8 h-full transition-all duration-300 hover:-translate-y-1"
                style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}
              >
                {/* Number Badge */}
                <div className="w-16 h-16 bg-[#EDD92A] rounded-full flex items-center justify-center mb-6 mx-auto">
                  <span className="text-3xl font-bold text-black">{step.number}</span>
                </div>

                {/* Title */}
                <h3 className="text-xl font-bold text-[#111111] mb-3 text-center">
                  {step.title}
                </h3>

                {/* Description */}
                <p className="text-sm text-gray-600 leading-relaxed text-center">
                  {step.description}
                </p>
              </div>

              {/* Arrow (Desktop only) */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-3 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-3xl text-[#EDD92A]"></i>
                </div>
              )}

              {/* Arrow (Mobile) */}
              {index < steps.length - 1 && (
                <div className="md:hidden flex justify-center my-4">
                  <i className="ri-arrow-down-line text-3xl text-[#EDD92A]"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Section CTA */}
        <div className="text-center">
          <a
            href="https://lin.ee/PJ9odjt"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-[#EDD92A] text-black font-bold px-8 py-4 rounded-2xl hover:shadow-xl transition-all duration-300 hover:-translate-y-1 whitespace-nowrap cursor-pointer"
            style={{ boxShadow: '0 6px 16px rgba(0,0,0,0.15)' }}
          >
            LINEで先行テスター/投稿者登録（無料）
          </a>
        </div>
      </div>
    </section>
  );
}
